// ── India Destinations ──────────────────────────────────────────────
export const INDIA_DEST = [];

// ── Long Haul ────────────────────────────────────────────────────────
export const LONGHAUL_DEST = [];

// ── City Destinations ─────────────────────────────────────────────────
export const CITY_DEST = [];

// ── Packages ─────────────────────────────────────────────────────────
export const PACKAGES = [];

// ── Brand Universes ──────────────────────────────────────────────────
export const BRANDS = [
  { id: 'retreats',   label: 'DIRA HOLIDAYS Retreats',          sub: 'Ultra-luxury escapes',         color: '#C9A84C', icon: 'hotel',     page: 'holidays'    },
  { id: 'adventures', label: 'DIRA HOLIDAYS Adventures',         sub: 'Thrill & adrenaline',          color: '#E53935', icon: 'mountain',  page: 'holidays'    },
  { id: 'journeys',   label: 'DIRA HOLIDAYS Personal Journeys',  sub: 'Crafted for your soul',        color: '#3949AB', icon: 'heart',     page: 'holidays'    },
  { id: 'escapes',    label: 'DIRA HOLIDAYS Escapes',            sub: 'Weekend getaways 2–5D',        color: '#00897B', icon: 'plane',     page: 'holidays'    },
  { id: 'getaways',   label: 'DIRA HOLIDAYS Getaways',           sub: 'Family & friends fun',         color: '#7B1FA2', icon: 'users',     page: 'holidays'    },
  { id: 'nomad',      label: 'DIRA HOLIDAYS Nomad',              sub: 'Digital nomad packages',       color: '#E65100', icon: 'globe',     page: 'holidays'    },
  { id: 'exp',        label: 'DIRA HOLIDAYS Experiences',        sub: 'Cultural immersions',          color: '#AD1457', icon: 'camera',    page: 'experiences' },
  { id: 'wander',     label: 'DIRA HOLIDAYS Wanderlust',         sub: 'Grand bucket-list tours',      color: '#1565C0', icon: 'map',       page: 'holidays'    },
  { id: 'explorer',   label: 'DIRA HOLIDAYS Explorer',           sub: 'Off-beat destinations',        color: '#2E7D32', icon: 'compass',   page: 'holidays'    },
  { id: 'corporate',  label: 'Corporate Business Tours',  sub: 'MICE & office travel',         color: '#37474F', icon: 'briefcase', page: 'corporate'   },
];

// ── Holiday Type Cards ───────────────────────────────────────────────
export const HOLIDAY_TYPES = [
  { label: 'Beach & Islands',  count: '120+ Packages', filterKey: 'Beach',     page: 'holidays'    },
  { label: 'Mountain & Trek',  count: '85+ Packages',  filterKey: 'Adventure', page: 'holidays'    },
  { label: 'City Break',       count: '96+ Packages',  filterKey: 'All',       page: 'destinations'},
  { label: 'Family Holidays',  count: '110+ Packages', filterKey: 'Family',    page: 'holidays'    },
  { label: 'Honeymoon',        count: '74+ Packages',  filterKey: 'All',       page: 'experiences' },
  { label: 'Adventure',        count: '62+ Packages',  filterKey: 'Adventure', page: 'holidays'    },
  { label: 'Luxury Retreat',   count: '48+ Packages',  filterKey: 'Luxury',    page: 'holidays'    },
  { label: 'Blind Date ',    count: 'Mystery!',       filterKey: 'All',       page: 'experiences', special: true },
];

// ── Testimonials ──────────────────────────────────────────────────────
export const TESTIMONIALS = [
  {
    name: 'Priya Sharma', city: 'Mumbai', brand: 'DIRA HOLIDAYS Retreats', rating: 5,
    text: '"The Maldives package was flawlessly organized. Every detail — from the seaplane transfer to the candlelight dinner on the sandbank — was sheer perfection."',
  },
  {
    name: 'Arjun Mehta', city: 'Delhi', brand: 'DIRA HOLIDAYS Adventures', rating: 5,
    text: '"Ladakh on two wheels — a dream I never thought I\'d live. Route, permits, homestays — all sorted. Just pure riding bliss from day one to the last."',
  },
  {
    name: 'Kavitha Nair', city: 'Bangalore', brand: 'DIRA HOLIDAYS Blind Date', rating: 5,
    text: '"My mystery trip was Coorg in monsoon season. I literally cried when I saw the misty hills. Best decision of my life — thank you DIRA HOLIDAYS!"',
  },
];

// ── Filter options for Holidays page ─────────────────────────────────
export const PKG_FILTERS = ['All', 'India', 'International', 'Luxury', 'Adventure', 'Beach', 'Short Break', 'Family'];

// ── Destination region tabs ────────────────────────────────────────────
export const DEST_REGIONS = [
  'India',
  'Malaysia',
  'Thailand',
  'Singapore',
  'China',
  'Japan',
  'Cambodia',
  'Indonesia',
  'Philippines',
  'Vietnam',
  'Laos',
];

// ── Region infer helper for fallback ──────────────────────────────────
export const inferRegion = (pkg = {}) => {
  if (pkg?.region && typeof pkg.region === 'string' && pkg.region.trim()) {
    return pkg.region.trim();
  }
  const name = (pkg?.name || '').toLowerCase();
  if (name.includes('bali') || name.includes('kintamani') || name.includes('indonesia') || name.includes('ubud') || name.includes('uluwatu')) return 'Indonesia';
  if (name.includes('hanoi') || name.includes('halong') || name.includes('vietnam') || name.includes('sapa') || name.includes('da nang') || name.includes('ho chi minh')) return 'Vietnam';
  if (name.includes('tokyo') || name.includes('japan') || name.includes('fuji') || name.includes('hakone')) return 'Japan';
  if (name.includes('cambodia') || name.includes('angkor') || name.includes('siem reap')) return 'Cambodia';
  if (name.includes('laos')) return 'Laos';
  if (name.includes('thailand') || name.includes('bangkok') || name.includes('phuket')) return 'Thailand';
  if (name.includes('india') || name.includes('tirupati') || name.includes('chennai') || name.includes('delhi')) return 'India';
  if (name.includes('china') || name.includes('beijing') || name.includes('shanghai') || name.includes('hangzhou')) return 'China';
  if (name.includes('singapore')) return 'Singapore';
  if (name.includes('philippines') || name.includes('manila') || name.includes('boracay')) return 'Philippines';
  if (name.includes('malaysia') || name.includes('kuala lumpur') || name.includes('langkawi') || name.includes('penang')) return 'Malaysia';
  return 'India';
};
